<div class="db-empty-search">
  <div class="db-empty-search-image-wrap" [ngClass]="{'db-plugins': page === 'plugins'}" *ngIf="!hideImage">
    <img class="db-empty-search" *ngIf="page !== 'plugins'" src="assets/images/icons/empty-search.svg" alt=""/>
    <img class="db-empty-search" *ngIf="page === 'plugins'" src="assets/images/illustrations/search.svg" alt=""/>
  </div>
  <div class="db-empty-search-title" [ngClass]="{'db-plugins': textTitle}" [innerHTML]="textTitle ? textTitle : ('text_emptySearchTitle' | dbText)"><span></span></div>
  <div class="db-empty-search-desc " *ngIf="page !== 'plugins'"><span>{{'text_emptySearchDescription' | dbText}}</span></div>
  <div class="db-empty-search-desc db-plugins" *ngIf="page === 'plugins'">For new plugins, go to <a (click)="showAvailablePlugins()">Add Plugin.</a> </div>
</div>
